







import { defineComponent } from '@vue/composition-api'
import { useGetters } from 'vuex-composition-helpers'
import GradeComponent from './Grade.vue'

export default defineComponent({
    name: 'GradesComponent',
    components: {
        GradeComponent
    },
    setup: () => {
        const { grades } = useGetters(['grades'])
        return { grades }
    }
})


